module.exports = __webpack_public_path__ + "img/srlogo-white.3479e847.png";